import gql from 'graphql-tag';

export interface UpdateGuestCheckinStatusResponse {
  updateGuestCheckinStatus: { ok: boolean };
}

export interface UpdateGuestCheckinStatusVariables {
  eventId: number;
  userId: string;
  checkIn: boolean;
  isSelfCheckin?: boolean;
}

export const UPDATE_GUEST_CHECKIN_STATUS_MUTATION = gql`
  mutation UpdateGuestCheckinStatus(
    $eventId: Int!
    $userId: Int!
    $checkIn: Boolean!
    $isSelfCheckin: Boolean
  ) {
    updateGuestCheckinStatus(
      eventId: $eventId
      userId: $userId
      checkIn: $checkIn
      isSelfCheckin: $isSelfCheckin
    ) {
      ok
    }
  }
`;

export interface UpdatePlusOneGuestCheckinStatusResponse {
  updatePlusOneGuestCheckinStatus: { ok: boolean };
}

export interface UpdatePlusOneGuestCheckinStatusVariables {
  eventId: number;
  input: {
    plusOneId: number;
    checkIn: boolean;
  };
}

export const UPDATE_PLUS_ONE_GUEST_CHECKIN_STATUS_MUTATION = gql`
  mutation UpdatePlusOneGuestCheckinStatus($eventId: Int!, $input: PlusOneGuestCheckinInput!) {
    updatePlusOneGuestCheckinStatus(eventId: $eventId, input: $input) {
      ok
    }
  }
`;

export interface UpdateEstimatedAttendanceResponse {
  UpdateEstimatedAttendance: { ok: boolean };
}

export interface UpdateEstimatedAttendanceVariables {
  eventId: number;
  requestId?: number | null;
  estimatedAttendees?: number | null;
  selectedGuestStatuses?: number[];
}

export const UPDATE_ESTIMATED_ATTENDANCE = gql`
  mutation UpdateEstimatedAttendance(
    $eventId: Int!
    $requestId: Int
    $estimatedAttendees: Int
    $selectedGuestStatuses: [String]
  ) {
    updateEstimatedAttendance(
      input: {
        eventId: $eventId
        requestId: $requestId
        estimatedAttendees: $estimatedAttendees
        selectedGuestStatuses: $selectedGuestStatuses
      }
    ) {
      ok
    }
  }
`;
